(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-carousel"]) return;
  try {
    
  (function() {
    // ============================================================================
    // OPTIMIZED UGC CAROUSEL - Lazy loading, efficient modal
    // ============================================================================
    
    let isInitialized = false;
    
    function initUGC() {
      if (isInitialized) return;
      isInitialized = true;
      
      const flickityTarget = document.querySelector('.flickity-carousel');
      const videoData = [];
      let modalVideos = []; // Pre-created modal videos

      if (flickityTarget) {
        document.querySelectorAll('.flickity-carousel .carousel-cell').forEach((cell, index) => {
          const video = cell.querySelector('video');
          if (!video) return;

          const source = video.querySelector('source');
          if (!source) return;

          videoData.push({
            src: source.src,
            productUrl: cell.getAttribute('href'),
            productImage: cell.dataset.productImage,
            name: cell.dataset.name,
            price: cell.dataset.price
          });

          video.addEventListener('click', e => {
            e.preventDefault();
            openModal(index);
          });
        });

        const flkty = new Flickity(flickityTarget, {
          contain: true,
          wrapAround: true,
          freeScroll: true,
          autoPlay: false,
          prevNextButtons: true,
          pageDots: false,
          lazyLoad: 1 // Lazy load adjacent cells
        });
        flickityTarget.flickityInstance = flkty;
      }

      const modal = document.getElementById('ugc-video-modal');
      const modalCarousel = document.querySelector('.ugc-modal-carousel');
      const productLink = document.getElementById('ugc-product-link');
      const productImage = document.getElementById('ugc-product-image');
      const productName = document.getElementById('ugc-product-name');
      const productPrice = document.getElementById('ugc-product-price');
      let currentModalIndex = 0;

      function openModal(index) {
        modal.classList.remove('hidden');
        
        // Only create modal videos once
        if (modalVideos.length === 0) {
          modalCarousel.innerHTML = '';
          videoData.forEach((item, i) => {
            const vid = document.createElement('video');
            vid.src = item.src;
            vid.loop = true;
            vid.muted = true;
            vid.controls = false;
            vid.playsInline = true;
            vid.classList.add('ugc-modal-video');
            vid.preload = 'none'; // Don't preload until needed
            modalCarousel.appendChild(vid);
            modalVideos.push(vid);
          });
        }

        showVideoAt(index);
      }

      function closeModal() {
        modal.classList.add('hidden');
        // Pause all modal videos but keep them in DOM
        modalVideos.forEach(vid => {
          vid.pause();
          vid.muted = true;
        });
      }

      function updateProductLabel(index) {
        const data = videoData[index];
        productLink.href = data.productUrl;
        productImage.src = data.productImage;
        productName.textContent = data.name;
        productPrice.textContent = data.price;
      }

      function showVideoAt(index) {
        currentModalIndex = index;

        modalVideos.forEach((vid, i) => {
          if (i === index) {
            vid.classList.add('active');
            vid.currentTime = 0;
            vid.muted = false;
            vid.load(); // Load current video
            vid.play().catch(() => {});
          } else if (Math.abs(i - index) <= 1) {
            // Preload adjacent videos
            vid.load();
            vid.classList.remove('active');
            vid.pause();
            vid.muted = true;
          } else {
            vid.classList.remove('active');
            vid.pause();
            vid.muted = true;
          }
        });

        updateProductLabel(index);
      }

      document.querySelector('.ugc-close').addEventListener('click', closeModal);
      document.querySelector('.ugc-prev').addEventListener('click', () => {
        currentModalIndex = (currentModalIndex - 1 + videoData.length) % videoData.length;
        showVideoAt(currentModalIndex);
      });
      document.querySelector('.ugc-next').addEventListener('click', () => {
        currentModalIndex = (currentModalIndex + 1) % videoData.length;
        showVideoAt(currentModalIndex);
      });

      let startX = 0;
      modal.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      });

      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          closeModal();
        }
      });

      modal.addEventListener('touchend', function (e) {
        let endX = e.changedTouches[0].clientX;
        let diffX = endX - startX;

        if (Math.abs(diffX) > 50) {
          if (diffX > 0) {
            currentModalIndex = (currentModalIndex - 1 + videoData.length) % videoData.length;
            showVideoAt(currentModalIndex);
          } else {
            currentModalIndex = (currentModalIndex + 1) % videoData.length;
            showVideoAt(currentModalIndex);
          }
        }
      });

      // Handle loading state
      const allVideos = Array.from(document.querySelectorAll('.ugc-carousel .carousel-cell video'));
      allVideos.forEach(video => {
        video.addEventListener('loadeddata', () => {
          const cell = video.closest('.carousel-cell');
          if (cell) {
            cell.classList.remove('loading');
          }
        }, { once: true });
      });

      // Optimized autoplay: only play currently visible video
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          
          if (entry.isIntersecting) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { 
        root: null, 
        threshold: 0.5, // Only play when 50% visible
        rootMargin: '50px' // Start loading slightly before in view
      });

      allVideos.forEach(video => observer.observe(video));
    }
    
    // Wait for Flickity library to load (it's deferred in theme.liquid)
    let flickityCheckAttempts = 0;
    const maxAttempts = 100; // 5 seconds max (100 * 50ms)
    
    function waitForFlickity() {
      if (typeof Flickity !== 'undefined') {
        initUGC();
      } else if (flickityCheckAttempts < maxAttempts) {
        // Flickity not loaded yet, check again in 50ms
        flickityCheckAttempts++;
        setTimeout(waitForFlickity, 50);
      } else {
        // Fallback: Flickity failed to load after 5 seconds
        console.error('UGC Carousel: Flickity library failed to load');
        // Remove loading shimmer so content is visible
        document.querySelectorAll('.ugc-carousel .carousel-cell').forEach(cell => {
          cell.classList.remove('loading');
        });
      }
    }
    
    // Initialize when window fully loads (ensures Flickity is available)
    if (document.readyState === 'complete') {
      // Already loaded
      waitForFlickity();
    } else {
      // Wait for full page load (including deferred scripts)
      window.addEventListener('load', waitForFlickity);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
